import { createSelector } from "reselect";

const selectMovies = (state) => state.movies;

export const selectLoadingStatus = createSelector(
  [selectMovies],
  (movies) => movies.isLoading,
);

export const selectVertualMovies = createSelector(
  [selectMovies],
  (movies) => movies.vertualMovies,
);

export const selectTrailerMovies = createSelector(
  [selectVertualMovies],
  (vertualMovies = []) =>
    vertualMovies.filter((movie) => movie.isBanner === true),
);

export const selectAllMovies = createSelector(
  [selectMovies],
  (movies) => movies.allMovies,
);

export const selectOrders = createSelector(
  [selectMovies],
  (movies) => movies.vertualOrders,
);

// export const selectOrderTotalPrice = createSelector([selectOrders], (orders) =>
//   orders.reduce((price, order) => price + order.price, 0),
// );

export const selectOrderTotalPrice = createSelector(
  [selectOrders, selectAllMovies],
  (orders, movies) => {
    // Create a map for fast lookup: { movieId: movie }
    const movieMap = movies.reduce((acc, movie) => {
      acc[movie._id] = movie;
      return acc;
    }, {});

    // Calculate total
    return orders.reduce((total, order) => {
      const movie = movieMap[order.movieId];
      return total + (movie?.price || 0);
    }, 0);
  },
);
